import { IconName } from "swing-components";

export type PossibleSlugs = "zip" | "school" | "sub-name" | "district";

type searchableTermsType = {
  slug: PossibleSlugs;
  icon: IconName;
  placeholder: string;
  labelName: string;
  searchString: (value: string) => string;
};

export const searchableTerms: searchableTermsType[] = [
  // Return all subs that are located near this zip.
  {
    slug: "zip",
    icon: "Location",
    placeholder: "XXXXX",
    labelName: "Zip Code",
    searchString: (value) => `located near ${value}`,
  },
  // Return all subs connected to this school.
  {
    slug: "school",
    icon: "School",
    placeholder: "XXXX-XXXX-XXXX-XXXX",
    labelName: "School UUID",
    searchString: (value) => `connected to school with UUID ${value}`,
  },
  //Return all subs connected to schools connected to this district.
  {
    slug: "district",
    icon: "Briefcase",
    placeholder: "XXXX-XXXX-XXXX-XXXX",
    labelName: "District UUID",
    searchString: (value) => `connected to district with UUID ${value}`,
  },

  // Return all subs that match this string.
  {
    slug: "sub-name",
    icon: "Person",
    placeholder: "John Doe",
    labelName: "Person Name",
    searchString: (value) => `name matches ${value}`,
  },
];
